import React, { Component } from 'react';
import Job from './Job';
import { Droppable } from 'react-beautiful-dnd';

export default class MemberJobList extends Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            isOpen: true,
        };
    }

    toggleAccordion = () => {
        this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
    };

    render() {
        const { isOpen } = this.state;

        return (
            <div className="order-jobs-holder">
                <div className="accordion">
                    <div className="accordion-header" onClick={this.toggleAccordion}>
                        <h5>
                            {this.props.member.name}{' '}
                            <span
                                style={{
                                    float: 'right',
                                    fontSize: '30px',
                                    cursor: 'pointer',
                                }}
                            >
                                {isOpen ? '-' : '+'}
                            </span>
                        </h5>
                    </div>
                    {isOpen && (
                        <div className="accordion-body">
                            {this.props.selectedJobs && this.props.selectedJobs.length > 0 && (
                                <button
                                    className="btn btn-cw-primary mt-auto mb-0"
                                    onClick={() => this.props.assignMultipleJobs(this.props.member.id)}
                                >
                                    Assign Jobs
                                </button>
                            )}

                            <Droppable droppableId={this.props.member.id.toString()}>
                                {(provided) => (
                                    <div
                                        className="table-container"
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                    >
                                        <div className="flex-table header transform-text">
                                            <div className="flex-row">Select</div>
                                            <div className="flex-row">Date Created</div>
                                            <div className="flex-row">Special Requests</div>
                                            <div className="flex-row">Site Address</div>
                                            <div className="flex-row">Job Number</div>
                                            <div className="flex-row">Type of Job</div>
                                            <div className="flex-row">Customer Name</div>
                                            <div className="flex-row">Actions</div>
                                            <div className="flex-row">Assign</div>
                                        </div>
                                        {this.props.jobs && this.props.jobs.length > 0 ? (
                                            this.props.jobs.map((job, index) => {
                                                const availableMembers = (this.props.members || []).filter(
                                                    (m) => m.value !== this.props.member.value
                                                );

                                                return (
                                                    <Job
                                                        key={job.id}
                                                        index={index}
                                                        job={job}
                                                        memberId={this.props.member.id}
                                                        onClick={this.props.onClick}
                                                        showModal={this.props.showModal}
                                                        members={availableMembers}
                                                        quickAssign={this.props.quickAssign}
                                                        updateSpecialRequests={this.props.updateSpecialRequests}
                                                        unassignJob={this.props.unassignJob}
                                                    />
                                                );
                                            })
                                        ) : (
                                            <p className="text-center mt-2">No jobs allocated</p>
                                        )}

                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
